<template>
  <div class="dictionary">
    <div class="item">
      <div class="title">关键词</div>
      <el-row>
        <el-col :span="15">
          <el-input v-model="query"  size="mini" />
        </el-col>
        <el-col :span="8" :offset="1">
          <el-button type="primary" size="mini" @click="getList">查询</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="item">
      <div class="title">查询结果</div>
      <ul class="lists">
        <li
          v-for="(item, index) in list"
          :key="index"
          :class="[{'active': active === item}]"
          @click="handleActive(item)"
        >
         {{ item.abstract }}
        </li>
      </ul>
    </div>
    <div class="tog">内容来源：聚点平台现代汉语大词典</div>
  </div>
</template>

<script>
import { getDockingDictionaries } from '@/api/index';
import dlgFunc from '../textProofreading/index.js';

export default {
  name: 'dictionary',
  data() {
    return {
      query: '',
      active: '',
      list: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      //  选中的文本
      this.query = dlgFunc.CWps.Application.Selection.Text;
      this.getList();
    });
  },
  methods: {
    async getList() {
      const user = JSON.parse(window.localStorage.wps);
      const res = await getDockingDictionaries({
        word: this.query,
        token: user.token,
      });
      if(res) {
        const data = JSON.parse(res.body);
        const { content = [] } = data;
        this.list = content;
        // this.active = content.length > 0 ? content[0].abstract : '',
      }
    },
    handleActive(val) {
      this.active = val;
    }
  }
}
</script>

<style scoped>
.dictionary {
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #F4F4F4
}

.item {
  background-color: #fff;
  border-radius: 5px;
  padding: 15px 20px;
  margin: 10px;
}

.title {
  font-size: 16px;
  padding-bottom: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}

.lists {
  height: 200px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
}

li {
  list-style-type: none;
  font-size: 12px;
  padding: 4px;
  border: 1px dashed #E8E8E8;
}

.active {
  background-color: #1890FF;
  color: #fff;
}

.tog {
  padding: 20px;
  text-align: right;
}
</style>